export const maxIcon = `<svg width="43" height="17" viewBox="0 0 43 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_4_341)">
            <path d="M37.4107 8.51401L35.2065 11.8986L38.3892 16.8052H42.9654L37.4107 8.51401Z" fill="white"/>
            <path d="M38.3397 0.623383L36.1257 3.88778L38.3397 7.1622L42.9061 0.623383H38.3397Z" fill="white"/>
            <path
                d="M27.4774 0.623383L32.9926 8.51402L27.4478 16.8052H32.0141L37.4108 8.51402L32.0438 0.623383H27.4774Z"
                fill="#0776AA"/>
            <path
                d="M10.7933 8.39387C10.7933 6.99198 11.584 6.55139 12.4142 6.55139C13.1753 6.55139 14.1736 6.99198 14.1736 8.44394V14.1116H17.8603V8.31376C17.8603 4.9292 16.8126 2.95654 13.541 2.95654C12.5921 2.95654 11.1491 3.56737 10.309 5.26966C9.7258 3.77765 8.54961 2.95654 6.43445 2.95654C5.48559 2.95654 4.04253 3.56737 3.66694 4.93922V3.23692H0V14.1016H3.68671V8.39387C3.68671 6.99198 4.47743 6.55139 5.30768 6.55139C6.06874 6.55139 7.07691 6.99198 7.07691 8.44394V14.1116H10.7933V8.39387V8.39387Z"
                fill="white"/>
            <path
                d="M26.7261 13.1503C26.0046 14.2317 24.3342 14.6423 23.4743 14.6423C20.6277 14.6423 17.7712 12.4093 17.7712 8.80442C17.7712 5.19956 20.6178 2.96655 23.4743 2.96655C24.1958 2.96655 25.8662 3.20688 26.7261 4.45856V3.19686H30.0273V14.3819H26.7261V13.1503V13.1503ZM24.0179 11.468C25.3819 11.468 26.7261 10.4867 26.7261 8.79441C26.7261 7.11214 25.4016 6.13082 24.0179 6.13082C22.6243 6.13082 21.2207 7.19225 21.2207 8.79441C21.2207 10.4066 22.6341 11.468 24.0179 11.468Z"
                fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0_4_341">
                <rect width="42.9655" height="16.1818" fill="white" transform="translate(0 0.623383)"/>
            </clipPath>
        </defs>
    </svg>`



// WEBPACK FOOTER //
// ./javascript/_common/icons/maxIcon.js